import { useNavigate } from 'react-router-dom';
import RetryButton from '@/components/buttons/RetryButton';
import LoadingScreen from '@/components/loading-screen';
import { BUSINESS_REQUIREMENT_ACTION } from '@/consts/businessRequirements';
import useBusinessRequirements from '@/hooks/useBusinessRequirements';
import { PATH_DASHBOARD } from '@/routes/paths';
import { BusinessRequirementsScreen } from '@/sections/@dashboard/business-requirements';

import { BusinessCreatePage } from '../../routes/elements';

// Os destinos ja existem e nenhum deles mexe nas jornadas: o Financeiro remonta
// o wizard de pre-cadastro sozinho, e o convite da validacao e a nova tentativa
// entram pelo mesmo state que a faixa do topo e o modal de status ja usam.
const ACTION_DESTINATION = {
  [BUSINESS_REQUIREMENT_ACTION.PRE_REGISTRATION]: [PATH_DASHBOARD.general.financial],
  [BUSINESS_REQUIREMENT_ACTION.PRODUCTS]: [PATH_DASHBOARD.general.products.root],
  [BUSINESS_REQUIREMENT_ACTION.VALIDATION]: [
    PATH_DASHBOARD.general.financial,
    { state: { openRegistrationValidationInvite: true } },
  ],
  [BUSINESS_REQUIREMENT_ACTION.RETRY_VALIDATION]: [
    PATH_DASHBOARD.general.financial,
    { state: { registrationValidationRetry: true } },
  ],
};

export default function BusinessCreateGate() {
  const navigate = useNavigate();
  const { isLoading, isError, canCreateBusiness, situation, refetch } = useBusinessRequirements();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (isError) {
    return (
      <RetryButton
        message="Não foi possível verificar a situação do seu cadastro."
        onClick={refetch}
      />
    );
  }

  if (canCreateBusiness) {
    return <BusinessCreatePage />;
  }

  const handleAction = (action) => {
    const destination = ACTION_DESTINATION[action];

    if (destination) {
      navigate(...destination);
    }
  };

  return (
    <BusinessRequirementsScreen
      situation={situation}
      onAction={handleAction}
      onClose={() => navigate(PATH_DASHBOARD.general.home)}
    />
  );
}
